module.exports = __webpack_public_path__ + "img/DS-M-3.dd22c921.svg";